<!-- <app-header-one [sticky]="true" *ngIf="url != '/pages/comingsoon'"></app-header-one> -->
<app-header-four [themeLogo]="themeLogo"></app-header-four>
<router-outlet></router-outlet>
<!-- <app-footer-one *ngIf="url != '/pages/comingsoon'"></app-footer-one> -->
<app-footer-four
  [class]="'footer-light pet-layout-footer'"
  [themeLogo]="themeLogo"
></app-footer-four>
